<template>
    <v-container>
        <v-card>
            <v-card-title>
                <div class="d-flex">
                    Usuarios
                    <v-spacer />
                    <v-btn
                        variant="tonal"
                        color="primary"
                        text="Agregar usuario"
                        prepend-icon="mdi-plus"
                        @click="showNewUserDialog"
                        size="small"
                    />
                </div>
            </v-card-title>
            <v-card-text>
                <v-list elevation="4">
                    <v-list-item-group v-if="loadingUsers" color="primary">
                        <v-skeleton-loader
                            class="mx-auto"
                            type="list-item"
                            :height="50"
                            :width="400"
                        />
                    </v-list-item-group>
                    <v-list-item-group v-else>
                        <v-list-item
                            v-for="user in users"
                            :key="user.id"
                            @click="showEditUserDialog(user)"
                        >
                            <v-list-item-title>
                                <div class="d-flex align-center ga-2">
                                    {{ user.name }}
                                    <v-spacer></v-spacer>
                                    <v-chip
                                        v-if="user.isAdmin"
                                        color="primary"
                                        variant="tonal"
                                        size="small"
                                        text="Administrador"
                                    />
                                    <v-chip
                                        v-if="!user.disabled"
                                        color="green"
                                        variant="tonal"
                                        size="small"
                                        text="Activo"
                                    />
                                    <v-chip
                                        v-if="user.disabled"
                                        color="red"
                                        variant="tonal"
                                        size="small"
                                        text="Deshabilitado"
                                    />
                                </div>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                Username {{ user.username }}
                            </v-list-item-subtitle>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-card-text>
        </v-card>

        <UserFormDialog
            v-model="showUserFormDialog"
            :user="userToUpdate"
            @close="userToUpdate = undefined"
            @update:user="fetchUsers"
            @create:user="fetchUsers"
        />
    </v-container>
</template>

<script lang="ts" setup>
import { SystemUser, AuthService, User } from '@/services/auth/authService';
import { onMounted, ref } from 'vue';
import UserFormDialog from '@/components/users/UserFormDialog.vue';

const authService = new AuthService()
const users = ref<SystemUser[]>([])
const loadingUsers = ref(false)
const userToUpdate = ref<SystemUser | undefined>()
const showUserFormDialog = ref(false)

async function fetchUsers() {
    loadingUsers.value = true
    users.value = await authService.getAllUsers()
    loadingUsers.value = false
}

function showNewUserDialog() {
    userToUpdate.value = undefined
    showUserFormDialog.value = true
}

function showEditUserDialog(user: SystemUser) {
    userToUpdate.value = user
    showUserFormDialog.value = true
}

onMounted(() => {
    fetchUsers()
})
</script>

<style lang="scss" scoped>

</style>